


























































































































getModule
import { Vue, Watch, Prop, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitaisRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteHospitaisRemuneracaoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalMotivosInclusao extends Vue {
  $refs: {
    form: any
  }

  @Prop(Boolean) isOpen!: boolean
  @Prop(Object) item!: {id: string; nome: string}

  showModalIncluir:boolean = false
  loadingIncluir:boolean = false
  loadingListagem:boolean = false
  loadingEditMotivo:boolean = false
  loadingExcluirMotivo:any = -1
  mode:string = '' 
  editingItemId: string  = ''

  form: any = {
    valid: true,
    motivoInclusao: [
      (v: any) => !!v || 'Campo obrigatório',
    ],
  }

  get getSuporteHospitaisRemuneracaoStore() {
    return getModule(SuporteHospitaisRemuneracaoStore, this.$store)
  }

  get showModalMotivosInclusao() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.motivosInclusao
  }

  set showModalMotivosInclusao(value: boolean) {
    this.getSuporteHospitaisRemuneracaoStore.setModal({
      name: 'motivosInclusao',
      value,
    })
  }
  
   get motivosInclusaoList() { return this.getSuporteHospitaisRemuneracaoStore.motivosInclusao }
   set motivosInclusaoList(value: any) { this.getSuporteHospitaisRemuneracaoStore.setMotivosInclusao(value) }

   get getMotivosInclusaoTableHeader() {
    return [
      { text: 'Motivo', class: 'table-headers', align: 'left', value: 'nome' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get motivoInclusao() { return this.getSuporteHospitaisRemuneracaoStore.motivoInclusao }
  set motivoInclusao(value: any) { this.getSuporteHospitaisRemuneracaoStore.setMotivoInclusao(value) }

  abrirModalIncluirMotivo(item, mode){
    if(item){
      this.editingItemId = item.id
    }

    this.mode = mode;
    this.showModalIncluir = true
    this.motivoInclusao = item ? item.motivo : ''
    this.$refs.form.resetValidation()
  }

  closeModalCriarEditar(){
    this.editingItemId = ''
    this.showModalIncluir = false
  }
  
  closeModal(){
    this.motivosInclusaoList = []
    this.showModalMotivosInclusao = false
  }

  async salvarMotivo(){
    if(!this.$refs.form.validate()){
      return
    }

    this.loadingIncluir = true

    const response = await this.getSuporteHospitaisRemuneracaoStore.criarEditarMotivoInclusao({idGrupoHospital: this.item.id, idMotivo: this.editingItemId, mode: this.mode})
    
    if(response && !response.success){
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
        this.loadingIncluir = false
        return
    }

    EventBus.$emit('setSnackbar', { show: true, text: `Motivo ${this.mode === 'create' ? 'criado' : 'editado'} com sucesso`,  icon: 'done', color: '#2E7D32' })
    this.loadingIncluir = false
    this.closeModalCriarEditar()
  }

  async excluirMotivo(item){
    this.loadingExcluirMotivo = item.id

    const response = await this.getSuporteHospitaisRemuneracaoStore.excluirMotivoInclusao({id: item.id, idGrupoHospital: this.item.id})
    
    if(response && !response.success){
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
        this.loadingExcluirMotivo = -1
        return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Motivo excluído com sucesso',  icon: 'done', color: '#2E7D32' })
    this.loadingExcluirMotivo = -1
  }

  @Watch('isOpen')
  async isOpenModal(val){
    if(val){
      this.loadingListagem = true
      await this.getSuporteHospitaisRemuneracaoStore.getMotivosInclusao(this.item.id);
      this.loadingListagem = false
    } 
  }
}
